<template>
    <div class='addShop'>
        
        <a-form layout="horizontal" :ref="torefs" :model="submitForm" :rules='rules' :label-col="labelCol" :wrapper-col="wrapperCol" >
            <df-titleline :title='"创建充值"'></df-titleline>

            <a-form-item label="选择商户" name="supplierId" class='required'>
                <df-selectShop @setValue='setValue' :model='submitForm'></df-selectShop>
            </a-form-item>

            <a-form-item label="业务模式" name="business">
                <a-radio-group v-model:value="submitForm.business" button-style="solid">
                    <a-radio-button v-for='(item,index) in businessList' :key='index' :value="item">
                        {{settlementsKeys[item]}}
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>

            <a-form-item label="充值平台" name="paymentType">
                <!-- <a-input v-model="submitForm.companyName" placeholder="企业名称" style='width:282px'/> -->

                <a-select v-model:value='submitForm.paymentType' style='width:282px'  allowClear placeholder='选择充值平台'>
                    <a-select-option v-for='(item,index) in plantformlist' :key='index' :value='item.id'>
                        {{item.name}}
                    </a-select-option>
                    
                </a-select>
            </a-form-item>

            <a-form-item label="第三方流水" name="paymentCode">
                <a-input v-model:value="submitForm.paymentCode" placeholder="第三方流水" style='width:282px'/>
            </a-form-item>
            
            <a-form-item label="充值金额" name="amount">
                <a-input v-model:value="submitForm.amount" addon-after="元" placeholder="充值金额" style='width:282px'/>
            </a-form-item>

            <a-form-item label="上传凭证" name="file"> 
                <!-- @preview="handlePreview" -->
                 <!-- @change="handleChange" -->
                 <!-- action="http://39.98.175.183:8999/upload/file/uploads" -->
      
                <a-upload
             
                    list-type="picture-card"
                    :file-list="fileList"
                    :before-upload="beforeUpload"
                    multiple
                    :remove='remove'
                    :disabled='fileList.length >= 5'
                    :customRequest='customRequest'
   
                    @preview="preview"
                >
                    <div>
                        <PlusOutlined />
                        <div class="ant-upload-text">
                        Upload
                        </div>
                    </div>
                </a-upload>
            
            </a-form-item>


            <a-form-item label="充值备注" name="remarks">
                <a-textarea placeholder="输入备注信息" v-model:value='submitForm.remarks' allow-clear style='width:282px;position:relative;top:5px'/>
            </a-form-item>
          
            <a-form-item :wrapper-col="{ span: 14, offset: 3 }" name="companyName">
                <a-button type="primary" size="large" @click="submitFormAction('submitForm')" :loading='loading' style='margin-top:20px'>
                    提交
                </a-button>

                <a-button  size="large" @click="submitFormAction('submitForm')"  style='margin-top:20px;margin-left:20px'>
                    重置
                </a-button>
             </a-form-item>
        
        </a-form>

        <a-modal v-model:visible="viewVisible" title="预览" width='800'>
            <!-- @ok="handleOk" -->
            <img :src='prevImg' style="width:100%">
        </a-modal>

    </div>
</template>

<script>
    import shopApi from '@axios/shop'
    import commonApi from '@axios/common'
    import { PlusOutlined } from '@ant-design/icons-vue';
    import { reactive, ref } from 'vue'
    import { message } from "ant-design-vue";
    import moneyApi from '@axios/money'
    import { useRouter } from 'vue-router'

    let VUE_APP_URL = process.env.VUE_APP_URL;
    export default {
        name: 'addShop',
        components: {
            PlusOutlined,
        },
        setup(){
            const router = useRouter();
            let itemrefs = [];
            const torefs = (el) => {
                itemrefs.push(el);
            }
            
            let checksupplierId = (rule, value, callback) => {
                console.log(value)
                if (!value) {
                    return Promise.reject('请选择供应商户');
                } else {
                    return Promise.resolve();
                }
            };

            let plantformlist = [
                {
                    id : '10',
                    name : '支付宝'
                },
                {
                    id : '20',
                    name : '微信'
                },
                {
                    id : '30',
                    name : '银行汇款'
                }
            ]

            let previewVisible  = ref(false);
            let previewImage = ref('');

            const rules =  {
                paymentType: [
                    { required: true, message: '请选择充值平台', trigger: 'change' }
                ],
                paymentCode: [
                    { required: true, message: '请输入第三方流水', trigger: 'blur' }
                ],
                amount: [
                    { required: true, message: '请输入金额', trigger: 'blur' }
                ],
                supplierId: [
                    
                    { validator: checksupplierId, trigger: 'blur' },
    
                ],
                remarks: [
                    { required: true, message: '备注不能为空', trigger: 'blur' }
                ],
                business: [
                    
                    { required: true, message: '选择业务场景', trigger: 'change' }
    
                ],
                


            };
            
            let fileList = ref([
                // {
                //     uid: '-1',
                //     name: 'image.png',
                //     status: 'done',
                //     url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
                // },
            
            ])

            const stateList = [
                {
                    name : '未开始',
                    val : 10
                },
                {
                    name : '签约中',
                    val : 20
                },
                {
                    name : '合作中',
                    val : 30
                },
                {
                    name : '已终结',
                    val : 40
                }
            ]

            const  upload_headers = {
                Authorization : 'Bearer ' + localStorage.getItem('token')
            };

            let loading = ref(false)

            const labelCol =  { span: 3 };
            const wrapperCol =  { span: 14 };
       
            let submitForm = ref({
                paymentType : '',
                paymentCode : '',
                amount : '',
                remarks : '',
                supplierId : undefined,
                business : undefined
            });
            const submitFormAction = () => {
                
            
                itemrefs[0].validate().then(()=>{
                    if(!fileList.value.length){
                        message.error('请上传图片');
                        return;
                    }

                    loading.value = true;
                    let params = {
                        supplierId : submitForm.value.supplierId,
                        business : submitForm.value.business,
                  
                        amount : submitForm.value.amount,
                        paymentType : submitForm.value.paymentType,
                        remarks : submitForm.value.remarks,
                        paymentCode : submitForm.value.paymentCode,
                        rechargeType:10
                    }
                    
                    let uparr = []
                    fileList.value.forEach((ele)=>{
                        uparr.push(ele.trueUrl);
                    })

                    params.paymentVoucher = uparr.join(',');

                    
                    moneyApi.supplierAddMoney(params).then((res)=>{
                        router.back(-1);
                    }).catch(()=>{
                        loading.value = false;
                    })
                   

                }).catch(err => {
                    console.log(err)
                })
            }

            let rmfile = 0;

            const beforeUpload = (file) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    message.error('请上传图片格式');
                }
                const isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    message.error('不能超过 20MB!');
                }
                
               
                if(rmfile >= 5){
                    message.error('最多只能上传五张图片');
                    return false;
                }

                if(isJpgOrPng && isLt2M){
                    rmfile++;    
                }
                return isJpgOrPng && isLt2M;
            }

            const customRequest = (file) => {

                console.log(file)
                let formData = new FormData();
                //多个文件上传
                formData.append("file", file.file);  // 文件对象
            
                commonApi.upload(formData).then((res)=>{
                    fileList.value.push({
                        uid : res[0].fileSize,
                        name : res[0].fileSize,
                        status : 'done',
                        trueUrl : res[0].filePath,
                        url :  process.env.VUE_APP_IMG_BASE + res[0].filePath,
                    })
                    
                })

            }

            const remove = (file) => {
                fileList.value.forEach((element,index)=>{
                    if(element.uid == file.uid){
                        fileList.value.splice(index,1);
                        rmfile--;
                       
                    }
                })
                
            }
            
            let viewVisible = ref(false);
            let prevImg = ref('');
            const preview = (info) => {
                viewVisible.value = true;
                prevImg.value = info.url
            }

            let businessList = ref([])

            const setValue = (val) => {
                submitForm.value.business = undefined
                businessList.value = val.business.split(',')
                console.log(businessList)
            }

            const settlementsKeys = {
                10 : '火车票',
                20 : '酒店',
                30 : '国内机票',
                40 : '国际机票',
                50 : '打车',
            }

            return {
                settlementsKeys,
                setValue,
                preview,
                prevImg,
                viewVisible,
                remove,
                customRequest,
                businessList,
                beforeUpload,
                submitFormAction,
                plantformlist,
                previewVisible,
                rules,
                fileList,
                VUE_APP_URL,
                stateList,
                upload_headers,
                loading,
                labelCol,
                wrapperCol,
                submitForm,
                torefs
            }
        },

    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .upload_images{
        width: 100px;
    }
    
  
</style>


